const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://x2c1yrbx5h.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://5p24xuq6yf.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.3',
    HOSTNAME: 'https://company.dev.apps.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.dev.apps.forwoodsafety.com',
    WEBSOCKET: 'wss://w7wfrjk2l6.execute-api.us-west-2.amazonaws.com/dev'
  },
};

export default config;